export default __webpack_public_path__ + "static/media/martinize_elastic_select1.9a4eb85b.png";